export const SET_USER_ROLE = 'setUserRole';
export const SET_USER = 'setUser';
